import { KeyboardDoubleArrowDown, KeyboardDoubleArrowLeft, KeyboardDoubleArrowRight } from "@mui/icons-material";
import { Box, Tab, Tabs, useTheme } from "@mui/material";
import { useCallback, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { routeToSingleUserAnalysisPage } from "../../app/constants/routes";
import { UiIconButton } from "../../components/ui/UiUtils";
import { tabStyle } from "../../styled/inlineCssStyles";
import { UserExtendedTabLayoutPopperView, UserTabLayoutLabelComp } from "./UserUIComponents";

export default function UserTabLayout({ activeTabId, tabItems }) {
  const theme = useTheme();
  const [isHovered, setIsHovered] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const tabContainerRef = useRef();

  const handleMouseEnter = useCallback(() => setIsHovered(true), []);
  const handleMouseLeave = useCallback(() => setIsHovered(false), []);
  const handleClickIcon = useCallback(() => {
    setAnchorEl(tabContainerRef.current);
    setIsHovered(false);
  }, [tabContainerRef]);
  const handleClose = useCallback(() => setAnchorEl(null), []);

  const renderedTabs = useMemo(
    () =>
      tabItems.map(({ ern, name, role }) => (
        <Tab
          disableRipple
          key={ern}
          value={ern}
          LinkComponent={Link}
          to={routeToSingleUserAnalysisPage(ern)}
          label={<UserTabLayoutLabelComp isActive={ern === activeTabId} userId={ern} userRole={role} userName={name} theme={theme} />}
        />
      )),
    [tabItems, activeTabId, theme]
  );

  return (
    <Box component="div" sx={{ position: "sticky", top: 0, zIndex: 101 }} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <Tabs
        ref={tabContainerRef}
        slots={{
          StartScrollButtonIcon: KeyboardDoubleArrowLeft,
          EndScrollButtonIcon: KeyboardDoubleArrowRight,
        }}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        value={activeTabId}
        sx={tabStyle()}
      >
        {renderedTabs}
      </Tabs>
      <Box sx={{ display: "flex", justifyContent: "center", visibility: !anchorEl && isHovered ? "visible" : "hidden" }}>
        <UiIconButton title="Click to open extended tab view" iconColor="text.primary" fontSize={10} onClickIcon={handleClickIcon}>
          <KeyboardDoubleArrowDown
            sx={{
              transform: `translateY(${!anchorEl && isHovered ? "-40px" : "0"})`,
              animation: "bounce 2s infinite",
              zIndex: -1,
              transition: "all 5ms",
            }}
          />
        </UiIconButton>
      </Box>
      <UserExtendedTabLayoutPopperView activeTabId={activeTabId} tabItems={tabItems} handleClose={handleClose} anchorEl={anchorEl} />
    </Box>
  );
}
